import { render, staticRenderFns } from "./CreateOrganizationAdminPage.vue?vue&type=template&id=61c01ba4&scoped=true"
import script from "./CreateOrganizationAdminPage.vue?vue&type=script&lang=ts"
export * from "./CreateOrganizationAdminPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c01ba4",
  null
  
)

export default component.exports